import React, { useEffect, useState } from 'react';
import Drawer from '@mui/material/Drawer';
import { ReactComponent as Funnel } from 'src/Images/icons/common/funnel.svg';
import { ReactComponent as BulletPoints } from 'src/Images/icons/common/bulletpoints.svg';
import { ReactComponent as Calendar } from 'src/Images/icons/common/calendar.svg';
import { ReactComponent as Refresh } from 'src/Images/icons/common/refresh.svg';
import { ReactComponent as Search } from 'src/Images/icons/common/search.svg';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import 'src/style/tableList.css';
import { ReactComponent as ArrowLeft } from 'src/Images/icons/common/arrowleft.svg';
import { ReactComponent as ArrowRight } from 'src/Images/icons/common/arrowright.svg';
import TableRightDrawer from 'src/components/PendingGrnVehicleEntry/List/TableRightDrawer';
import Table from 'src/components/PendingGrnVehicleEntry/List/Table';
import TableContent from 'src/components/PendingGrnVehicleEntry/List/TableContent';
import { getVehicleTrackingAwaitingGrn } from 'src/redux/Actions/VehicleTracking';
import Breadcrumb from 'src/components/Breadcrumb';
import { useSetBreadcrumbData } from 'src/utils/SetBreadcrumbData';
import usePageTitle from 'src/utils/SetPageTitle';
import { useLocation } from 'react-router-dom';

export default function PendingGrnVehicleEntry() {
  usePageTitle(`Pending Grn Vehicle Entry`);
  const location = useLocation();
  const dispatch = useDispatch();
  const [searchInput, setSearchInput] = useState(null);
  const vehicleTrackingReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const fieldFilter =
    vehicleTrackingReducer?.vehicleTrackingAwaitingGrn?.fieldMapping;
  const [draggedFieldOrder, setDraggedFieldOrder] = useState([]);
  const [showFunnel, setShowFunnel] = useState(false);
  const [selectedFieldFilter, setSelectedFieldFilter] = useState([
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
  ]);
  const [searchInputChange, setSearchInputChange] = useState('');
  const searchTexts = ['Vehicle Tracking Code'];
  const tableHeaders =
    vehicleTrackingReducer?.vehicleTrackingAwaitingGrn?.selectedFields;
  const totalPages =
    vehicleTrackingReducer?.vehicleTrackingAwaitingGrn?.totalPages;
  const tableFieldFilter =
    draggedFieldOrder.length > 0 ? draggedFieldOrder : selectedFieldFilter;
  const tenantOrganisationId = authReducer.userData.organisations?.id;
  const [pageNumber, setPageNumber] = useState(1);
  const [tableDataSort, setTableDataSort] = useState(1);
  const [tableSortField, setTableSortField] = useState(null);
  const [formData, setFormData] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearchInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    dispatch(
      getVehicleTrackingAwaitingGrn(
        pageNumber,
        searchInput,
        tableDataSort,
        tableSortField,
        tableFieldFilter,
        tenantOrganisationId,
      ),
    );
  }, [
    dispatch,
    pageNumber,
    searchInput,
    tableDataSort,
    tableSortField,
    selectedFieldFilter,
    draggedFieldOrder,
  ]);

  function handleSearchFilter() {
    const searchPayload = {
      start_date: formData.startDate || null,
      end_date: formData.endDate || null,
    };

    const params = new URLSearchParams();
    Object.entries(searchPayload).forEach(([key, value]) => {
      Array.isArray(value)
        ? value.forEach((item) => params.append(key, item))
        : value && params.append(key, value);
    });

    const queryString = params.toString();

    dispatch(
      getVehicleTrackingAwaitingGrn(
        pageNumber,
        searchInput,
        tableDataSort,
        tableSortField,
        tableFieldFilter,
        tenantOrganisationId,
        queryString,
      ),
    );
  }

  function handleResetFilter() {
    setSelectedFieldFilter(['1', '2', '3', '4', '5', '6', '7']);
    setFormData({
      startDate: null,
      endDate: null,
    });
  }

  const handleFunnelToggle = () => {
    setShowFunnel(!showFunnel);
  };

  const handleTableSortOrder = (value, field) => {
    setTableDataSort(value);
    setTableSortField(field);
  };

  const handleInputChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!Number.isNaN(value) && value >= 1 && value <= totalPages) {
      setPageNumber(value);
    }
  };

  const handleNextPage = () => {
    if (pageNumber < totalPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  const handlePreviousPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  const formattedPageNumber = pageNumber < 10 ? `0${pageNumber}` : pageNumber;

  useEffect(() => {
    const interval = setInterval(() => {
      setSearchInputChange(
        (prev) =>
          searchTexts[(searchTexts.indexOf(prev) + 1) % searchTexts.length],
      );
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const handleSelectedFieldFilter = (e, value) => {
    const updatedSelectedFieldFilter = [...selectedFieldFilter];
    if (e.target.checked) {
      updatedSelectedFieldFilter.push(value);
    } else {
      const index = updatedSelectedFieldFilter.indexOf(value);
      if (index > -1) {
        updatedSelectedFieldFilter.splice(index, 1);
      }
    }
    setSelectedFieldFilter(updatedSelectedFieldFilter);
  };

  const [openDrawer, setOpenDrawer] = useState(false);
  const [openGRNDrawer, setOpenGRNDrawer] = useState(false);

  const toggleDrawer = (open) => () => {
    setOpenDrawer(open);
  };

  const handleSearchInput = (e) => {
    const { value } = e.target;
    setSearchInput(value);
  };

  useSetBreadcrumbData(location.pathname, 'Pending Grn Vehicle Entry');

  return (
    <div className="div-flex-column padding-top-8 ">
      <div className="page-layout div-flex-column rg-5">
        <div className="div-space-between slider-padding left-padding">
          <div className="div-flex-row cg-5">
            <Breadcrumb />
          </div>
          <Col xxl={2} xl={2} lg={2} className="right-padding">
            <div className="input-wrapper">
              <input
                type="text"
                className="form-input-section input-icon-remove"
                placeholder={`Search by ${searchInputChange}`}
                value={searchInput || ''}
                onChange={handleSearchInput}
              />
              <span className="form-input-section-icon">
                <Search className="icon-size-lg" />
              </span>
            </div>
          </Col>
        </div>
        <div className="div-space-between slider-padding border-bottom">
          <span className="text-xxl text-bold left-padding">
            Pending GRN Vehicle Entry
          </span>
          <div className="div-flex-row div-align-center cg-20 right-padding">
            <div className="div-flex-row cg-20 div-align-center">
              <div className="list-container div-flex-column rg-5">
                <button
                  className="icon-btn-none"
                  onClick={handleFunnelToggle}
                  aria-label="Funnel"
                >
                  <Funnel className="icon-size-lg" color="#9F9F9F" />
                </button>
              </div>
              <div className="button-container">
                <button
                  className="icon-btn-none"
                  onClick={toggleDrawer(true)}
                  aria-label="Organiser"
                >
                  <BulletPoints className="icon-size-lg" color="#9F9F9F" />
                </button>
                <Drawer
                  anchor="right"
                  open={Boolean(openDrawer)}
                  onClose={toggleDrawer(false)}
                  ModalProps={{
                    keepMounted: false,
                  }}
                  sx={{ zIndex: 1 }}
                >
                  <div className="right-drawer-component-small">
                    <TableRightDrawer
                      toggleDrawer={toggleDrawer}
                      fieldFilter={fieldFilter}
                      selectedFieldFilter={selectedFieldFilter}
                      handleSelectedFieldFilter={handleSelectedFieldFilter}
                      setDraggedFieldOrder={setDraggedFieldOrder}
                    />
                  </div>
                </Drawer>
              </div>
              <button
                className="icon-btn-none"
                onClick={() => window.location.reload()}
                aria-label="Refresh"
              >
                <Refresh className="icon-size-lg" color="#9F9F9F" />
              </button>
            </div>
          </div>
        </div>
        <Row className="g-0">
          <Col
            xxl={showFunnel ? 10 : 12}
            xl={showFunnel ? 9 : 12}
            lg={showFunnel ? 8 : 12}
            md={showFunnel ? 8 : 12}
            sm={showFunnel ? 0 : 12}
            xs={showFunnel ? 0 : 12}
            className="border-bottom"
          >
            <Table
              headers={tableHeaders}
              minCellWidth={150}
              tableContent={
                <TableContent
                  headers={tableHeaders}
                  setOpenGRNDrawer={setOpenGRNDrawer}
                  openGRNDrawer={openGRNDrawer}
                />
              }
              tableDataSort={tableDataSort}
              handleTableSortOrder={handleTableSortOrder}
            />
            <div className="footer-container left-padding right-padding">
              <div className="div-space-between div-align-center">
                <div className="div-flex-row cg-20 pagination-container div-align-center">
                  <div className="div-flex-row cg-10 div-align-center">
                    <button
                      className="icon-btn-none"
                      onClick={handlePreviousPage}
                      aria-label="Arrow Left"
                    >
                      <ArrowLeft className="icon-size-sm" />
                    </button>
                    <input
                      className="page-number-container input-icon-remove text-sm"
                      defaultValue={formattedPageNumber}
                      onChange={handleInputChange}
                      type="number"
                      max={totalPages}
                    />
                    <button className="icon-btn-none" onClick={handleNextPage}>
                      <ArrowRight
                        className="icon-size-sm"
                        aria-label="Arrow Right"
                      />
                    </button>
                  </div>
                  <span className="text-grey text-md">
                    Page {pageNumber} of {totalPages}
                  </span>
                </div>
                <button
                  className={`common-btn theme-background-${themeColor}`}
                  onClick={() => setOpenGRNDrawer(true)}
                >
                  Create GRN
                </button>
              </div>
            </div>
          </Col>
          {showFunnel && (
            <Col
              xxl={showFunnel ? 2 : 0}
              xl={showFunnel ? 3 : 0}
              lg={showFunnel ? 4 : 0}
              md={showFunnel ? 4 : 0}
              sm={showFunnel ? 12 : 0}
              xs={showFunnel ? 12 : 0}
              className="border-left border-bottom"
            >
              <div className="filter-list-item border-bottom">
                <span className="text-sm text-semi-bold">Filter</span>
              </div>
              <div className="div-flex-column div-space-between rg-20">
                <div className="filter-list-item-container-scroll div-flex-column">
                  <div className="filter-list-item div-flex-column rg-5">
                    <span className="text-sm text-semi-bold">Start Date</span>
                    <div className="input-wrapper">
                      <input
                        name="startDate"
                        className="form-input-section input-icon-date"
                        size="small"
                        type="date"
                        value={formData.startDate || ''}
                        onChange={handleSearchInputChange}
                      />
                      <span className="form-input-section-icon">
                        <Calendar className="icon-size-sm" />
                      </span>
                    </div>
                  </div>
                  <div className="filter-list-item div-flex-column">
                    <div className="div-flex-column rg-5">
                      <span className="text-sm text-semi-bold">End Date</span>
                      <div className="input-wrapper">
                        <input
                          name="endDate"
                          className="form-input-section input-icon-date"
                          size="small"
                          type="date"
                          value={formData?.endDate || ''}
                          onChange={handleSearchInputChange}
                        />
                        <span className="form-input-section-icon">
                          <Calendar className="icon-size-sm" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div-flex-row div-space-between div-align-center border-top filter-list-item footer-content-for-component">
                  <button
                    className={`common-btn-outlined border-${themeColor}`}
                    onClick={handleResetFilter}
                  >
                    Reset
                  </button>
                  <button
                    className={`common-btn theme-background-${themeColor}`}
                    onClick={handleSearchFilter}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </Col>
          )}
        </Row>
      </div>
    </div>
  );
}
